import React from 'react';

export default function NotFound() {
  return (
    <div>
      <h1>Not Found</h1>
      <p className='lead'>The page you are looking for doesn't exists.</p>
    </div>
  );
}
